import { render, staticRenderFns } from "./ExhibitionCard.vue?vue&type=template&id=a19fc640&scoped=true&"
import script from "./ExhibitionCard.vue?vue&type=script&lang=js&"
export * from "./ExhibitionCard.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionCard.vue?vue&type=style&index=0&id=a19fc640&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19fc640",
  null
  
)

export default component.exports